<template>
  <v-card flat fill-height style="height:100%;width:100%;">
    <v-card-title v-if="canNavigate" style="height:10%;cursor:pointer;" v-on:click="navTo()" v-on:mouseleave="color='rgb(95,158,239)'" v-on:mouseover="color='rgb(51,82,128)'">
      <div primary class="title" :style="'color:'+color+';'">{{ title }}</div>
      <v-icon :color="color">play_arrow</v-icon>
    </v-card-title>
    <v-card-title v-else style="height:10%;">
      <div primary class="title">{{ title }}</div>
    </v-card-title>
    <!--<v-card-actions fill-height style="height:90%; padding: 0;">-->
    <v-card-actions fill-height style="height:90%;">
      <v-container fluid grid-list-md fill-height style="padding:0px 10px 5px 10px;width:100%;">
        <v-layout row style="height:100%;width:100%;">
          <v-flex d-flex md5>
            <v-layout column fill-height>
              <v-flex d-flex md1 style="align-items:center;font-size:18px;">Engine KPI</v-flex>
              <v-flex d-flex md3>
                <div v-if="engineData.engineKPI<0" style="display:flex;align-items:center;justify-content:center;font-size:36px;">-</div>
                <div v-else-if="engineData.engineColor==20" style="color:rgb(205, 57, 64);display:flex;align-items:center;justify-content:center;font-size:36px;">{{ engineData.engineKPI }} %</div>
                <div v-else style="color:rgb(117,117,117);display:flex;align-items:center;justify-content:center;font-size:36px;">{{ engineData.engineKPI }} %</div>
              </v-flex>
              <v-flex d-flex md2 style="align-items:center;justify-content:center;">
                <div v-if="engineData.engineColor==0" :style="'height:30px; border:none; color:rgb(60, 171, 48); background-color:rgb(60, 171, 48); width:' + engineData.engineKPI+ '%;' "/>
                <div v-else-if="engineData.engineColor==10" :style="'height:30px; border:none; color:rgb(255, 184, 29); background-color:rgb(255, 184, 29); width:' + engineData.engineKPI+ '%;' "/>
                <div v-else :style="'height:30px; border:none; color:rgb(205, 57, 64); background-color:rgb(205, 57, 64); width:' + engineData.engineKPI+ '%;' "/>
                <div :style="'height:30px; border:none; color:rgb(244,244,244);  background-color:rgb(244,244,244); width:' + (100-engineData.engineKPI)+ '%;' "/>
              </v-flex>
              <v-flex d-flex md1 style="align-items:center;font-size:18px;">Cylinders</v-flex>
              <v-flex d-flex md2>
                <v-layout row>
                  <v-flex d-flex v-for="(item,index) in engineData.cylinders" v-bind:key="item" style="font-size:24px;font-weight:bold;color:white;">
                    <div v-if="item==0" style="display:flex;justify-content:center;align-items:center;background-color:rgb(60, 171, 48);">{{ index + 1 }}</div>
                    <div v-else-if="item==10" style="display:flex;justify-content:center;align-items:center;background-color:rgb(255, 184, 29);">{{ index + 1 }}</div>
                    <div v-else-if="item==20" style="display:flex;justify-content:center;align-items:center;background-color:rgb(205, 57, 64);">{{ index + 1 }}</div>
                    <div v-else style="display:flex;justify-content:center;align-items:center;background-color:rgb(219,219,219);">{{ index + 1 }}</div>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex d-flex md1 style="align-items:center;font-size:18px;">Other Components</v-flex>
              <v-flex d-flex md2>
                <v-layout row>
                  <v-flex d-flex v-for="item in engineData.elements" v-bind:key="item" style="font-size:14px;font-weight:bold;color:white;">
                    <div v-if="item.color==0" style="display:flex;justify-content:center;align-items:center;background-color:rgb(60, 171, 48);">{{ item.name }}</div>
                    <div v-else-if="item.color==10" style="display:flex;justify-content:center;align-items:center;background-color:rgb(255, 184, 29);">{{ item.name }}</div>
                    <div v-else-if="item.color==20" style="display:flex;justify-content:center;align-items:center;background-color:rgb(205, 57, 64);">{{ item.name }}</div>
                    <div v-else style="display:flex;justify-content:center;align-items:center;background-color:rgb(219,219,219);">{{ item.name }}</div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex d-flex md5>
            <v-layout fill-height column>
              <v-layout v-for="sys in subSystemData" :key="sys" row style="height:15px;">
                <v-flex d-flex md3 style="justify-content:center;align-items:center;">
                  <v-avatar flat>
                    <img v-if="sys.value==20" :src=red>
                    <img v-else-if="sys.value==10" :src=orange>
                    <img v-else-if="sys.value==0" :src=green>
                    <img v-else :src=gray>
                  </v-avatar>
                </v-flex>
                <v-flex md9 d-flex style="align-items:center;font-size:20px;">{{ sys.system }}</v-flex>
              </v-layout>
            </v-layout>
          </v-flex>

          <v-flex d-flex md2>
            <v-layout column>
              <v-flex v-if="typeof faults != 'undefined' && canNavigate" d-flex md3 style="justify-content:center;align-items:center;font-size:54px;background-color:rgb(219,219,219);margin:5px;max-height:25%;cursor:pointer;" v-on:click="navTo()" class="hoverItem">{{ faults.length }}</v-flex>
              <v-flex v-else d-flex md3 style="justify-content:center;align-items:center;font-size:54px;background-color:rgb(219,219,219);margin:5px;max-height:25%;cursor:pointer;">0</v-flex>

              <v-flex d-flex md2 style="color:rgb(115,115,115);text-align:center;font-size:13px;margin:5px;max-height:15%;">Individual issues detected</v-flex>
              <v-flex d-flex md7 style="max-height: 60%;">
                <v-layout column style="overflow-y:auto;height:100%;">
                  <v-flex d-flex v-for="el in elements" :key="el" style="font-size:16px;justify-content:center;align-items:center;max-height:35px;background-color:rgb(219,219,219);margin:5px;border-radius:25px;">{{ el }}</v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
import Tooltip from "../components/tooltip";
import {DxDataGrid, DxColumn, DxPaging, DxScrolling} from 'devextreme-vue/data-grid';

import {globalStore} from "../main.js"

export default {
  name: "FaultsTwinWidget",
  components: {
    Tooltip,
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxScrolling
  },
  props: {
    navigation: Boolean,
    engine: String,
    title: String
  },
  data: function () {
    return {
      color: 'rgb(95,158,239)',
      red: require('../assets/RedLight.png'),
      orange: require('../assets/OrangeLight.png'),
      green: require('../assets/GreenLight.png'),
      gray: require('../assets/check-mark-circle3.png'),
      subSystemData: [],
      engineData: {
        cylinders: [],
        elements: [],
        engineKPI: 0,
        engineColor: 0
      },
      canNavigate: false,
      faults: []
    }
  },
  methods: {
    navTo() {
      //set selected engine
      globalStore.faults = globalStore.twinFaults[this.engine];
      globalStore.signals = globalStore.twinSignals[this.engine];
      globalStore.reference = globalStore.twinReference[this.engine];
      globalStore.selectedEngine = this.engine;

      this.$router.push( { name:  'Engine Faults' , params:{'vessel':this.$route.params.vessel, 'eng':  this.engine}} )
    },
    setData() {
      if (typeof globalStore.twinSignals != 'undefined' && typeof globalStore.twinReference != 'undefined' && typeof globalStore.twinSignals[this.engine] != 'undefined' && typeof globalStore.twinReference[this.engine] != 'undefined') {
        let timestamp = ((Object.keys(globalStore.twinReference[this.engine]).indexOf('average') > -1) ? 'average' : globalStore.twinReference[this.engine]['lastDate']),
            kpi = globalStore.twinReference[this.engine][timestamp]['eng_KPI'] * 100;
        this.$set(this.engineData, 'engineColor', globalStore.twinReference[this.engine][timestamp]['eng_KPI_color']);

        if (kpi.toFixed(1) != '100.0')
          this.$set(this.engineData, 'engineKPI', kpi.toFixed(1));
        else
          this.$set(this.engineData, 'engineKPI', kpi.toFixed(0));

        this.engineData.cylinders = [];

        for (let c = 1; c <= this.cylCount; c++)
          this.engineData.cylinders.push(globalStore.twinReference[this.engine][timestamp]['cyl' + c + '_KPI_color']);

        let names = ['Turbines', 'Compressors', 'A/F', 'A/C'],
            tags = ['turb', 'comp', 'ac', 'af'];

        this.engineData.elements = [];

        for (let el = 0; el < names.length; el++) {
          let sum = 0;

          for (let t = 1; t <= this.tcCount; t++) {
            sum += globalStore.twinReference[this.engine][timestamp][tags[el] + t + '_KPI_color'];
          }

          this.engineData.elements.push({
            name: names[el],
            color: sum / this.tcCount
          });
        }

        this.subSystemData = [];
        names = [['Servo Oil', 'Exhaust Gas', 'Piston Running'], ['Fuel Injection', 'Scavenge Air', 'Automation & Control']];
        tags = [['so_KPI_color', 'egs_KPI_color', 'pr_KPI_color'], ['fi_KPI_color', 'sac_KPI_color', 'ca_KPI_color']];

        this.subSystemData = [];
        names = ['Servo Oil', 'Fuel Injection', 'Exhaust Gas', 'Scavenge Air', 'Piston Running', 'Automation & Control'];
        tags = ['so_KPI_color', 'fi_KPI_color', 'egs_KPI_color', 'sac_KPI_color', 'pr_KPI_color', 'ca_KPI_color'];

        if (globalStore.gasEngine) {
          names.splice(5, 0, 'Gas Admission');
          tags.splice(5, 0, 'gas_KPI_color');
        }

        for (let sys = 0; sys < names.length; sys++) {
          this.subSystemData.push({
            system: names[sys],
            value: globalStore.twinReference[this.engine][timestamp][tags[sys]]
          });
        }

        this.faults = globalStore.twinFaults[this.engine];
        this.elements = this.faults.map(x => x.element + ' ' + x.index).filter((item, i, ar) => ar.indexOf(item) === i);
        this.canNavigate = true;
      } else {
        this.$set(this.engineData, 'engineKPI', -0);
        this.$set(this.engineData, 'engineColor', -1000);

        this.engineData.cylinders = [];
        for (let c = 1; c <= this.cylCount; c++)
          this.engineData.cylinders.push(-10);

        let names = ['Turbines', 'Compressors', 'A/F', 'A/C'],
            tags = ['turb', 'comp', 'ac', 'af'];

        this.engineData.elements = [];

        for (let el = 0; el < names.length; el++) {
          let sum = 0;

          for (let t = 1; t <= this.tcCount; t++) {
            sum += -10;
          }

          this.engineData.elements.push({
            name: names[el],
            color: sum / this.tcCount
          });
        }

        this.subSystemData = [];
        names = ['Servo Oil', 'Fuel Injection', 'Exhaust Gas', 'Scavenge Air', 'Piston Running', 'Automation & Control'];
        tags = ['so_KPI_color', 'fi_KPI_color', 'egs_KPI_color', 'sac_KPI_color', 'pr_KPI_color', 'ca_KPI_color'];

        if (globalStore.gasEngine) {
          names.splice(5, 0, 'Gas Admission');
          tags.splice(5, 0, 'gas_KPI_color');
        }

        for (let sys = 0; sys < names.length; sys++) {
          this.subSystemData.push({
            system: names[sys],
            value: -1000
          });
        }

        this.canNavigate = false;
      }
    }
  },
  mounted() {
    this.setData();
  },
  watch: {
    dataLoaded: function () {
      if (this.dataLoaded != '')
        this.setData();
    }
  },
  computed: {
    dataLoaded: function () {
      return globalStore.type;
    },
    cylCount: function () {
      return globalStore.cylCount;
    },
    tcCount: function () {
      return globalStore.tcCount;
    },
    engines: function () {
      return Object.keys(globalStore.twinSignals);
    }
  }
}
</script>

<style scoped>

.hoverItem {
  color: rgb(95, 158, 239)
}

.hoverItem:hover {
  color: rgb(51, 82, 128)
}

#table {
  font-size: 14px;
  font-family: 'Roboto', 'sans seriff';
}

.v-avatar img {
  height: 32px;
  width: 32px;
}
</style>
